import { applyMiddleware, createStore } from "redux"

import promise from "redux-promise-middleware"
import thunk from "redux-thunk"
import { createLogger  } from "redux-logger"

import history from './history'

import { connectRouter, routerMiddleware } from 'connected-react-router'

import reducer from "./reducers"

const middleware = applyMiddleware(promise(), thunk, createLogger(), routerMiddleware(history))

export default createStore(connectRouter(history)(reducer), middleware)


// WEBPACK FOOTER //
// ./src/store.js